
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/broadcasters",
      function () {
        return require("private-next-pages/broadcasters/index.tsx");
      }
    ]);
  